import { Box, Button, Card, Container, FormLabel, Stack, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useNavigate, useLocation } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { SlCloudUpload } from 'react-icons/sl';
import Swal from 'sweetalert2';
import { LoadingButton } from '@mui/lab';

import {
  getCleanerSetting,
  createCleanerSetting,
  deleteUploads,
  getBanner,
  getContactInfo,
  uploadFile,
  sendCleanerMessage,
  sendCleanerMessageToday,
  sendCleanerMessageCalender,
  sendCleanerMessageTomorrow,
} from '../helper/backend_helper';
import appConfig from '../config';
import InfoTooltip from '../components/InfoTooltip';
// import logo from 'src/components/logo';

const CleanerSetting = () => {
  const [bannerData, setBannerData] = useState({});

  const [calenderTime, setCalenderTime] = useState('');
  const [calenderHeader, setCalenderHeader] = useState('');
  const [calenderFooter, setCalenderFooter] = useState('');
  const [tomorrowTime1, setTomorrowTime1] = useState('');
  const [tomorrowTime2, setTomorrowTime2] = useState('');
  const [tomorrowHeader, setTomorrowHeader] = useState('');
  const [tomorrowFooter, setTomorrowFooter] = useState('');
  const [todayTime, setTodayTime] = useState('');
  const [todayHeader, setTodayHeader] = useState('');
  const [todayFooter, setTodayFooter] = useState('');
  const [checkoutMessage, setCheckoutMessage] = useState('');
  const [checkoutMsgWhatsappNo, setCheckoutMsgWhatsappNo] = useState('');
  const [VAT, setVAT] = useState(0);
  const [ignoreAverageCalValue, setIgnoreAverageCalValue] = useState(0);

  const [specialCleanerDays, setSpecialCleanerDays] = useState(0);
  const [specialCleanerTimes, setSpecialCleanerTimes] = useState(0);
  const [alertMessage, setAlertMessage] = useState('');
  const [cleaningCost, setCleaningCost] = useState(0);
  const [bedSheetCost, setBedSheetCost] = useState(0);

  const [loading, setLoading] = useState(false);
  const [sendMessageLoading, setSendMessageLoading] = useState(false);

  const Banner = async () => {
    try {
      const bannerResponse = await getCleanerSetting();
      setBannerData(bannerResponse?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    Banner();
  }, []);
  useEffect(() => {
    setCalenderTime(bannerData?.calenderTime || '');
    setCalenderHeader(bannerData?.calenderHeader || '');
    setCalenderFooter(bannerData?.calenderFooter || '');
    setTomorrowTime1(bannerData?.tomorrowTime1 || '');
    setTomorrowTime2(bannerData?.tomorrowTime2 || '');
    setTomorrowHeader(bannerData?.tomorrowHeader || '');
    setTomorrowFooter(bannerData?.tomorrowFooter || '');
    setTodayTime(bannerData?.todayTime || '');
    setTodayHeader(bannerData?.todayHeader || '');
    setTodayFooter(bannerData?.todayFooter || '');
    setCheckoutMessage(bannerData?.checkoutMessage || '');
    setCheckoutMsgWhatsappNo(bannerData?.checkoutMsgWhatsappNo || '');
    setVAT(bannerData?.VAT || 0);
    setIgnoreAverageCalValue(bannerData?.ignoreAverageCalValue || 0);
    setSpecialCleanerDays(bannerData?.specialCleanerDays || 0);
    setSpecialCleanerTimes(bannerData?.specialCleanerTimes || 0);
    setAlertMessage(bannerData?.alertMessage || '');
    // setCleaningCost(bannerData?.cleaningCost || 0);
    // setBedSheetCost(bannerData?.bedSheetCost || 0);
  }, [bannerData]);

  const handleSave = async () => {
    try {
      setLoading(true);

      const BannerData = {
        calenderTime,
        calenderHeader,
        calenderFooter,
        tomorrowTime1,
        tomorrowTime2,
        tomorrowHeader,
        tomorrowFooter,
        todayTime,
        todayHeader,
        todayFooter,
        checkoutMessage,
        checkoutMsgWhatsappNo,
        VAT,
        ignoreAverageCalValue,
        specialCleanerDays,
        specialCleanerTimes,
        alertMessage,
        cleaningCost,
        bedSheetCost,
      };

      console.log(BannerData);

      const Categoryheaders = {
        headers: {
          'Content-Type': 'application/json',
        },
      };

      const response = await createCleanerSetting(BannerData, Categoryheaders);

      Swal.fire({
        icon: 'success',
        title: 'Cleaner Settings updated successfully',
      });

      setLoading(false);
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error while updating Cleaner Settings',
      });
    }
  };

  const sendMessage = async () => {
    try {
      setSendMessageLoading(true);
      await sendCleanerMessage();
      setSendMessageLoading(false);
    } catch (error) {
      setSendMessageLoading(false);
      console.log(error);
    }
  };

  const sendMessageToday = async () => {
    try {
      await sendCleanerMessageToday();
    } catch (error) {
      console.log(error);
    }
  };
  const sendMessageCalender = async () => {
    try {
      await sendCleanerMessageCalender();
    } catch (error) {
      console.log(error);
    }
  };
  const sendMessageTomorrow = async () => {
    try {
      await sendCleanerMessageTomorrow();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Helmet>
        <title> Cleaner Settings </title>
      </Helmet>
      <Card sx={{ padding: 3 }}>
        <Stack mt={3} direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="h3">Cleaner Notifications Settings{' '}<InfoTooltip width={20} title="Configures the automated WhatsApp messages sent to cleaners about their schedules, plus cleaning cost settings. Set the send times and header/footer text for the calendar, tomorrow and today notifications, the checkout message, VAT and special/regular cleaner rules. Edit a section and click its Send Message button to trigger it now, or Update to save all settings." /></Typography>

          <Button
            sx={{
              marginBottom: 3,
              boxShadow: 'none',
              backgroundColor: '#1E3A5F',
              '&:hover': {
                backgroundColor: '#1E3A5F',
                boxShadow: 'none',
              },
            }}
            variant="contained"
            onClick={sendMessage}
          >
            {sendMessageLoading ? 'Sending...' : 'Send Message'}
          </Button>
        </Stack>

        <Box
          component="form"
          sx={{
            '& .MuiTextField-root': { width: { xs: '100%', sm: '50ch' } }, // Responsive
          }}
          noValidate
          autoComplete="off"
        >
          <Stack mt={3} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
            <Typography mt={3} variant="h4">
              Calendar Notifications
            </Typography>
            <Button
              sx={{
                marginBottom: 3,
                boxShadow: 'none',
                backgroundColor: '#1E3A5F',
                '&:hover': {
                  backgroundColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              variant="contained"
              onClick={sendMessageCalender}
            >
              {sendMessageLoading ? 'Sending...' : 'Send Message'}
            </Button>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Calendar Time <InfoTooltip title="Time of day the weekly calendar overview is sent to cleaners via WhatsApp." /></FormLabel>
              <TextField
                label="Calendar Time"
                id="outlined-size-small"
                type="time" // Ensures 24-hour format is used
                value={calenderTime}
                onChange={(e) => setCalenderTime(e.target.value)}
                InputLabelProps={{ shrink: true }} // Keeps label visible
                inputProps={{ step: 300 }} // Optional: 5-minute steps (adjustable)
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Calendar Header <InfoTooltip title="Intro text shown at the top of the calendar notification sent to cleaners." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Calendar Header "
                id="outlined-size-small"
                value={calenderHeader}
                onChange={(e) => setCalenderHeader(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Calendar Footer <InfoTooltip title="Closing text shown at the bottom of the calendar notification sent to cleaners." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Calendar Footer "
                id="outlined-size-small"
                value={calenderFooter}
                onChange={(e) => setCalenderFooter(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack mt={3} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
            <Typography mt={3} variant="h4">
              Tomorrow Notifications
            </Typography>
            <Button
              sx={{
                marginBottom: 3,
                boxShadow: 'none',
                backgroundColor: '#1E3A5F',
                '&:hover': {
                  backgroundColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              variant="contained"
              onClick={sendMessageTomorrow}
            >
              {sendMessageLoading ? 'Sending...' : 'Send Message'}
            </Button>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={1} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Tomorrow Time1 <InfoTooltip title="First time of day the next-day cleaning schedule reminder is sent to cleaners." /></FormLabel>
              <TextField
                label="Enter Tomorrow Time1"
                id="outlined-size-small"
                type="time" // Ensures 24-hour format is used
                value={tomorrowTime1}
                onChange={(e) => setTomorrowTime1(e.target.value)}
                InputLabelProps={{ shrink: true }} // Keeps label visible
                inputProps={{ step: 300 }} // Optional: 5-minute steps (adjustable)
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Tomorrow Time2 <InfoTooltip title="Second time of day the next-day cleaning schedule reminder is sent to cleaners." /></FormLabel>
              <TextField
                label="Enter Tomorrow Time2"
                id="outlined-size-small"
                type="time" // Ensures 24-hour format is used
                value={tomorrowTime2}
                onChange={(e) => setTomorrowTime2(e.target.value)}
                InputLabelProps={{ shrink: true }} // Keeps label visible
                inputProps={{ step: 300 }} // Optional: 5-minute steps (adjustable)
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Tomorrow Header <InfoTooltip title="Intro text shown at the top of the next-day schedule notification sent to cleaners." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Tomorrow Header "
                id="outlined-size-small"
                value={tomorrowHeader}
                onChange={(e) => setTomorrowHeader(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Tomorrow Footer <InfoTooltip title="Closing text shown at the bottom of the next-day schedule notification sent to cleaners." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Tomorrow Footer "
                id="outlined-size-small"
                value={tomorrowFooter}
                onChange={(e) => setTomorrowFooter(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack mt={3} direction="row" alignItems="center" justifyContent="flex-start" spacing={2}>
            <Typography mt={3} variant="h4">
              Today Notifications
            </Typography>
            <Button
              sx={{
                marginBottom: 3,
                boxShadow: 'none',
                backgroundColor: '#1E3A5F',
                '&:hover': {
                  backgroundColor: '#1E3A5F',
                  boxShadow: 'none',
                },
              }}
              variant="contained"
              onClick={sendMessageToday}
            >
              {sendMessageLoading ? 'Sending...' : 'Send Message'}
            </Button>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={1} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Today Time <InfoTooltip title="Time of day the same-day cleaning schedule notification is sent to cleaners." /></FormLabel>
              <TextField
                label="Today Time"
                id="outlined-size-small"
                type="time" // Ensures 24-hour format is used
                value={todayTime}
                onChange={(e) => setTodayTime(e.target.value)}
                InputLabelProps={{ shrink: true }} // Keeps label visible
                inputProps={{ step: 300 }} // Optional: 5-minute steps (adjustable)
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Today Header <InfoTooltip title="Intro text shown at the top of the same-day schedule notification sent to cleaners." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Today Header "
                id="outlined-size-small"
                value={todayHeader}
                onChange={(e) => setTodayHeader(e.target.value)}
              />
            </Stack>
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Today Footer <InfoTooltip title="Closing text shown at the bottom of the same-day schedule notification sent to cleaners." /></FormLabel>
              <TextField
                multiline
                rows={4}
                label="Enter Today Footer "
                id="outlined-size-small"
                value={todayFooter}
                onChange={(e) => setTodayFooter(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              {' '}
              <FormLabel sx={{ mb: 1 }}>Checkout Message <InfoTooltip title="Message sent after a guest checks out, e.g. a thank-you or review request." /></FormLabel>
              <TextField
                multiline
                minRows={4}
                label="Enter Message"
                id="outlined-size-small"
                value={checkoutMessage}
                onChange={(e) => setCheckoutMessage(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Checkout Message Number <InfoTooltip title="WhatsApp number that the checkout message is sent to." /></FormLabel>
              <TextField
                label="Enter No"
                id="outlined-size-small"
                value={checkoutMsgWhatsappNo}
                onChange={(e) => setCheckoutMsgWhatsappNo(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Cleaning VAT <InfoTooltip title="VAT percentage applied to cleaning costs in reports and statements." /></FormLabel>
              <TextField
                type="number"
                label="Enter VAT"
                id="outlined-size-small"
                value={VAT}
                onChange={(e) => setVAT(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Ignore Amount In Average Cal <InfoTooltip title="Costs at or below this amount are excluded from average cleaning/bedsheet cost calculations." /></FormLabel>
              <TextField
                type="number"
                label="Enter No"
                id="outlined-size-small"
                value={ignoreAverageCalValue}
                onChange={(e) => setIgnoreAverageCalValue(e.target.value)}
              />
            </Stack>
          </Stack>

          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Special Cleaner Days <InfoTooltip title="Number of days a special cleaner remains assigned before reverting to the regular cleaner." /></FormLabel>
              <TextField
                type="number"
                label="Enter Days Number"
                id="outlined-size-small"
                value={specialCleanerDays}
                onChange={(e) => setSpecialCleanerDays(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Regular Cleaner Times <InfoTooltip title="Number of cleanings after which a property reverts to its regular cleaner." /></FormLabel>
              <TextField
                type="number"
                label="Enter Times Number"
                id="outlined-size-small"
                value={specialCleanerTimes}
                onChange={(e) => setSpecialCleanerTimes(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>In Complete Cleaning Alert <InfoTooltip title="Message sent to alert when a cleaning report is left incomplete or missing required details." /></FormLabel>
              <TextField
                multiline
                minRows={4}
                label="Enter Message"
                id="outlined-size-small"
                value={alertMessage}
                onChange={(e) => setAlertMessage(e.target.value)}
              />
            </Stack>
          </Stack>
          {/* <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Default Cleaning Cost</FormLabel>
              <TextField
                multiline
                label="Enter Cost"
                id="outlined-size-small"
                value={cleaningCost}
                onChange={(e) => setCleaningCost(e.target.value)}
              />
            </Stack>
          </Stack>
          <Stack spacing={{ xs: 2, sm: 4 }} mt={4} direction="row" useFlexGap flexWrap="wrap">
            <Stack sx={{ width: { xs: '100%', sm: '45%' } }}>
              <FormLabel sx={{ mb: 1 }}>Default BedSheet Cost</FormLabel>
              <TextField
                multiline
                label="Enter Cost"
                id="outlined-size-small"
                value={bedSheetCost}
                onChange={(e) => setBedSheetCost(e.target.value)}
              />
            </Stack>
          </Stack>
          */}
        </Box>

        <LoadingButton
          sx={{
            // width: 150,
            mt: 4,
            mb: 4,
            boxShadow: 'none',
            backgroundColor: '#1E3A5F',
            '&:hover': {
              backgroundColor: '#1E3A5F',
              boxShadow: 'none',
            },
          }}
          variant="contained"
          onClick={handleSave}
          loading={loading}
        >
          Update
        </LoadingButton>
      </Card>
    </>
  );
};

export default CleanerSetting;
